import React from 'react';
import { Button, Text } from 'src/@vymo/ui/atoms';
import { Card } from 'src/@vymo/ui/blocks';
import { Widget } from 'src/@vymo/ui/molecules';
import { ReactComponent as RightArrow } from 'src/assets/copilot/right_arrow.svg';
import { setFilters } from 'src/models/filters/slice';
import { REVYRE_LIST, REVYRE_WORKFLOW_LIST } from 'src/modules/constants';
// eslint-disable-next-line vymo-ui/restrict-import
import { REVYRE } from 'src/modules/revyre/constants';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import { renderModule } from 'src/workspace/slice';
import { getWorkflowHelloCards } from '../selectors';
import styles from './index.module.scss';

function RevyreHelloCards() {
  const workflowHelloCards = useAppSelector(getWorkflowHelloCards);
  const dispatch = useAppDispatch();
  if (workflowHelloCards?.length === 0) {
    return null;
  }

  const onCategoryClick = (workflowHelloCard, category) => {
    const { workflowType } = workflowHelloCard;
    const filters = category.filters || {};
    const filterContext = `revyre_${workflowType}_default`;
    dispatch(setFilters({ context: filterContext, filters }));

    if (REVYRE.COLLECT_IQ.DOMAIN_TYPES.includes(workflowType)) {
      dispatch(
        renderModule({
          id: REVYRE_LIST,
          props: {
            domainType: workflowType,
          },
        }),
      );
    } else {
      dispatch(
        renderModule({
          id: REVYRE_WORKFLOW_LIST,
          props: {
            domainType: 'workflow',
            workflowType,
          },
        }),
      );
    }
  };

  return (
    <div className={styles.helloCardWrapper}>
      {workflowHelloCards?.map((workflowHelloCard) => (
        <Widget
          key={workflowHelloCard.workflowType}
          title={workflowHelloCard.name}
          content={
            <div className={styles.helloCardWrapper__card}>
              {workflowHelloCard.pages?.map((page) => (
                <div
                  key={`${workflowHelloCard.workflowType}-${page.code}`}
                  className={styles.helloCardWrapper__categoryWrapper}
                >
                  {page.categories.map((category) => (
                    <Card
                      key={`${workflowHelloCard.workflowType}-${page.code}-${category.code}`}
                      classNames={
                        styles.helloCardWrapper__categoryWrapper__card
                      }
                    >
                      {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */}
                      <div
                        onClick={() =>
                          onCategoryClick(workflowHelloCard, category)
                        }
                      >
                        <div
                          className={
                            styles.helloCardWrapper__categoryWrapper__card__header
                          }
                        >
                          <Text>{category.name}</Text>
                          <Button
                            className={
                              styles.helloCardWrapper__categoryWrapper__card__button
                            }
                            type="text"
                            iconProps={{
                              icon: <RightArrow />,
                              iconPosition: 'left',
                            }}
                          />
                        </div>
                        <div
                          className={
                            styles.helloCardWrapper__categoryWrapper__card__content
                          }
                        >
                          <Text
                            classNames={
                              styles.helloCardWrapper__categoryWrapper__card__value
                            }
                            type="h5"
                          >
                            {category.value}
                          </Text>
                        </div>
                      </div>
                    </Card>
                  ))}
                </div>
              ))}
            </div>
          }
        />
      ))}
    </div>
  );
}

export default RevyreHelloCards;
